import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './DryerVent.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import GenesisAiContent from "../GenesisAiContent/GenesisAiContent";
import emailjs from 'emailjs-com';
import img11 from '../../Images/11.jpg'
import img12 from '../../Images/12.jpg'
import img22 from '../../Images/dryercleaning.jpg'
import img23 from '../../Images/dryercleaned.jpg'

export default function DryerVent({ CitiePhone, locationsMain, CitiesData }) {

    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);

    const fireRocketCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "rocket_dryer_vent_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE ROCKET AIRCARE?",
                "content": "Rocket AirCare is a trusted name in dryer vent cleaning and maintenance. With years of experience and advanced equipment, we provide thorough cleaning and repair services to ensure your home is safe and your appliances are efficient. Our commitment to customer satisfaction sets us apart."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We specialize in dryer vent cleaning, repair, inspection, and installation. Our services also include lint removal, vent connection fixes, fire hazard prevention, and airflow optimization. Our goal is to provide a safer and more efficient drying experience for every customer."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our dryer vent cleaning starts at just $79. Repair and installation services are competitively priced and include a free initial consultation to assess your needs. You’ll receive clear, upfront pricing with no hidden fees."
            },
            {
                "title": "CAN YOU CLEAN AND REPAIR AT THE SAME TIME?",
                "content": "Yes, we can! Rocket AirCare provides same-day cleaning and repair services for dryer vents. If our inspection identifies any issues, our skilled technicians can address them immediately, ensuring your system is both clean and functional."
            },
            {
                "title": `DO YOU PROVIDE SERVICES SURROUNDING ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} and the surrounding areas. Our service radius covers up to 75 miles, ensuring that homes and businesses nearby can access our high-quality dryer vent services.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with Rocket AirCare is simple! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.`
            },
            {
                "title": "HOW OFTEN SHOULD DRYER VENTS BE CLEANED?",
                "content": "Dryer vents should be cleaned at least once a year, or more frequently for households with heavy dryer use. Regular cleaning prevents lint buildup, improves drying efficiency, and reduces fire hazards."
            },
            {
                "title": "WHY IS DRYER VENT CLEANING IMPORTANT?",
                "content": "Dryer vent cleaning is essential for preventing fire hazards caused by lint buildup. It also improves dryer performance, reduces energy costs, and extends the lifespan of your appliance. Neglecting this service can lead to costly repairs and safety risks."
            }
        ]
    };
    const styles = {
        bgColor: '#FBF6E9',
        titleTextColor: '#182d43',
        titleTextSize: '18px',
        rowTitleColor: '#182d43',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const aiKd = url.searchParams.get('kd');
                const aiLoc = url.searchParams.get('open_ai_location');
                const aiCity = aiLoc ? aiLoc.split(',').map(p => p.trim().replace(/-/g, ' ')).join(', ') : '';
                const aiTopic = aiKd && aiKd !== 'null' ? aiKd : 'dryer vent cleaning';
                const searchKeyword = `I need from you 32 words about "${aiTopic}"${aiCity ? ` in ${aiCity}` : ''} and how we "Rocket Air Care" can help our clients with that kind of service. Give me that as a json file: title (3 words, include words from the service${aiCity ? ' and the city' : ''}, do not include the words "null" or "Rocket Air Care") and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="DryerVent" id="homepage">
<Helmet>
    {/* <!-- TITLE --> */}
    <title>Rocket Air Care | Dryer Vent Lint Removal & Fire Prevention | 866-950-4606</title>

    {/* <!-- META TITLE (max 35 characters) --> */}
    <meta name="title" property="title" content="Rocket Air Care | Dryer Vent Lint Removal & Fire Prevention | 866-950-4606" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="Rocket Air Care | Dryer Vent Lint Removal & Fire Prevention | 866-950-4606" data-react-helmet="true" />

    {/* <!-- META INFO --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og-dryervent.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.rocketaircare.com/dryer-vent" data-react-helmet="true" />

    {/* <!-- DESCRIPTION (Title Case) --> */}
    <meta name="description" content="Rocket Dryer Vent Cleaning Removes Lint Buildup, Improves Airflow, And Reduces Fire Hazards To Keep Your Home Safe And Your Dryer Running Efficiently." data-react-helmet="true" />
    <meta name="og:description" property="og:description" content="Rocket Dryer Vent Cleaning Removes Lint Buildup, Improves Airflow, And Reduces Fire Hazards To Keep Your Home Safe And Your Dryer Running Efficiently." data-react-helmet="true" />

    {/* <!-- SITE NAME --> */}
    <meta name="og:site_name" property="og:site_name" content="Rocket Dryer Vent Services" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta name="keywords" content="Dryer Vent Cleaning, Lint Removal, Dryer Safety, Fire Hazard Prevention, Vent Inspection, Clogged Dryer Vent, Improve Dryer Efficiency, Residential Dryer Vent, Dryer Duct Cleaning, Dryer Vent Maintenance, Rocket Dryer Vent Services" data-react-helmet="true" />
</Helmet>

            {/* MainBanner */}
            <div className="MainBanner" >
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftRight">

                    <img className="bannerlogopng" src={require(`../../ImagesLogos/Logo1.png`)} />

                        <h1>Don't Sweat It, Call Rocket Air Care</h1>
                        <h4>Top-Rated <b>Dryer Vent Service</b> in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h4>
                        <h2>Rocket Air Care is the the leading Dryer Vent team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. Give us a call at <span>{CitiePhone}</span> to schedule your service.
                        </h2>
                        <h3><img src={require(`../../Images/check.png`)} />Affortable Pricing & No Hidden Fees</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Fully stocked trucks</h3>
                        <h3><img src={require(`../../Images/check.png`)} />1800+ 5-Star Reviews</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                        </div>
                        <div className="MainBannerLeftRated" >
                            <h3>Rated 5 on Google</h3>
                            <span>
                                <h4>5</h4>
                                <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                            </span>
                        </div>
                    </div>
                    <div className="MainBannerLeftLeft">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                    </div>

                </div>
                <div className="MainBannerImg">
                    <img src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
            </div>
            {/* DryerVentReviews */}
            <div className="DryerVentReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="DryerVentReviewsList">
                    <img className="bannerlogopng" src={require(`../../Images/review1airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review3airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review2airduct.png`)} />
                </div>
            </div>
            {/* GenesisAiContent — keyword-driven section, /local ads pages only */}
            <GenesisAiContent response={response} />
            {/* DryerVentBenefits */}
            <div className="DryerVentBenefits">
                <h1>Benefits of Cleaning Your <span>Dryer Vent</span></h1>
                <div className="DryerVentBenefitsBox">
                    <div className="DryerVentBenefitsBoxImg">
                        <img src={require(`../../Images/ben2.png`)} alt="Dust Problem" />
                    </div>
                    <div className="DryerVentBenefitsBoxBox">
                        <h2>Excessive Lint Build-Up?</h2>
                        <h3>Is lint piling up despite regular cleaning? A clogged dryer vent could be the issue, reducing efficiency and posing a fire hazard. Our expert cleaning services will ensure your vents are clear and safe.</h3>
                    </div>
                </div>
                <div className="DryerVentBenefitsBox">
                    <div className="DryerVentBenefitsBoxImg">
                        <img src={require(`../../Images/ben3.png`)} alt="Allergy Relief" />
                    </div>
                    <div className="DryerVentBenefitsBoxBox">
                        <h2>Clothes Taking Longer to Dry?</h2>
                        <h3>If your clothes are still damp after a normal cycle, it’s a clear sign of a clogged dryer vent. Let us clean your vents to restore optimal drying performance and save you time and energy.</h3>
                    </div>
                </div>
                <div className="DryerVentBenefitsBox">
                    <div className="DryerVentBenefitsBoxImg">
                        <img src={require(`../../Images/ben1.png`)} alt="Mold Issues" />
                    </div>
                    <div className="DryerVentBenefitsBoxBox">
                        <h2>Noticing Mold or Mildew?</h2>
                        <h3>If you see or smell mold near your dryer, the vent might be trapping moisture. Our dryer vent cleaning service will help eliminate moisture buildup, preventing mold growth and improving safety.</h3>
                    </div>
                </div>
                <div className="DryerVentBenefitsBox">
                    <div className="DryerVentBenefitsBoxImg">
                        <img src={require(`../../Images/ben4.png`)} alt="Energy Savings" />
                    </div>
                    <div className="DryerVentBenefitsBoxBox">
                        <h2>Higher Energy Bills?</h2>
                        <h3>A clogged vent makes your dryer work harder, using more energy and increasing your bills. We’ll clean your dryer vent to enhance efficiency and lower energy costs.</h3>
                    </div>
                </div>
                <h4>TAKE THE FIRST STEP TOWARD A SAFER AND MORE <span>EFFICIENT HOME</span>, SCHEDULE YOUR DRYER VENT CLEANING TODAY!</h4>
                <div className="DryerVentBenefitsbutn">
                    <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning | Dryer Vent Repair | Dryer Vent Services | Dryer Vent Inspection" /></a>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryercleaning.jpg`)} alt="Dryer Vent Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>DRYER VENT CLEANING</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Lint Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Clogged Vent Clearing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Improved Dryer Efficiency</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryerrepair.jpg`)} alt="Dryer Vent Repair" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>DRYER VENT REPAIR</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Damaged Vent Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Sealing Leaks</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Vent Connection Fixes</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Enhanced Safety Standards</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryerinspection.jpg`)} alt="Dryer Vent Inspection" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>DRYER VENT INSPECTION</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Fire Risk Assessment</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Airflow Testing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Moisture Build-Up Detection</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Professional Recommendations</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>AIR DUCT CLEANING</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Allergen Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Mold Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Air Quality Testing</h2>
                        </div>
                    </a>

                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                    { key: "hvac", label: "HVAC", href: "/hvac", match: (a) => /hvac|^ac |furnace repair|furnace install|heat pump|mini-split|thermostat|refrigerant/i.test(a.Title) },
                    { key: "roofing", label: "Roofing & Gutters", href: "/roofing", match: (a) => /roof|gutter|skylight|soffit|fascia/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            <div className="AirDuctWeondawy">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} alt="Air Duct Cleaning" />
                <h1>Stay calm, we're coming to you!</h1>

            </div>
            {/* DryerVentbefore */}
            <div className="DryerVentBefore">
                <div className="DryerVentBeforeLeft">
                    <h1>THE IMPORTANCE OF CLEAN DRYER VENTS</h1>
                    <h2>Protect Your Home, Save Energy, and Ensure Safety</h2>
                    <h3>Your dryer vent plays a crucial role in ensuring the safety and efficiency of your home. Over time, lint, debris, and other contaminants build up in the vent, creating a significant fire hazard and reducing your dryer's performance. A clogged vent can also increase drying times, drive up energy bills, and shorten the lifespan of your dryer. Regular dryer vent cleaning not only enhances safety but also improves energy efficiency and ensures your appliance runs smoothly. Protect your home and loved ones—schedule professional dryer vent cleaning today!</h3>
                    <h2>Safer Home, Better Efficiency—The Choice Is Yours</h2>
                    <h3>Regular dryer vent cleaning is not just about maintaining your appliance; it's about safeguarding your family and home. Clogged vents are a leading cause of house fires and can trap moisture, leading to mold growth and reduced air quality. Clean vents promote better airflow, reduce drying times, and lower energy consumption, helping you save money and prevent costly repairs. Take control of your home's safety and efficiency with professional dryer vent cleaning—you'll notice the difference immediately!</h3>
                    <h4>Booking with Rocket AirCare is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="DryerVentBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>ROCKET BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Technicians completed more than 2,500 hours of training in 2023</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 1,800+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* DryerVentGoodBY */}
            <div className="DryerVentGoodBY">
                <h1>SAY GOODBYE TO LINT AND CLOGGED VENTS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience safer, more efficient drying with our professional dryer vent cleaning services.</h2>
                <div className="DryerVentGoodBYList">
                    <img src={require(`../../Images/dryercleaned.jpg`)} />
                    <img src={require(`../../Images/dryercleaned2.jpg`)} />
                    <img src={require(`../../Images/dryercleaned3.jpg`)} />
                    <img src={require(`../../Images/dryercleaned4.jpg`)} />
                </div>
            </div>
            {/* MainBanner */}
            <div className="DryerVentBook">
                <div className="MainBannerLeftRight">
                    <h1>Book Your Dryer Vent Service Online Now in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h1>
                    <h4>Top-Rated <b>Dryer Vent Service</b></h4>
                    <h2>Rocket Air Care: Your Trusted Dryer Vent Cleaning Team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. 📅 Schedule Your Appointment Online in less then a Minute</h2>
                    <h3><img src={require(`../../Images/check.png`)} /> Affordable Pricing & No Hidden Fees – Book Online Today!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Licensed, Bonded, & Insured Professionals Ready to Serve You</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Fully Stocked Trucks for Next-Day Service – Schedule Now!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Trusted by 1800+ 5-Star Reviews – Join Our Happy Customers!</h3>
                    <div className="MainBannerLeftButtons" id="book">
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 5 on Google</h3>
                        <span>
                            <h4>5</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerLeftLeft">
                    <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                </div>

            </div>
            {/* DryerVentHowit work */}
            <div className="DryerVentHowIt">
                <h1>How It Works</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>All It Takes is Three Easy Steps</h2>
                <div className="DryerVentHowItList">
                    <div className="DryerVentHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit1.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Call Our Office</h4>
                        <h5>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to speak to one of our experts regarding the issue you are experiencing.</h5>
                    </div>
                    <div className="DryerVentHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit2.png`)} />
                        <h3>STEP 2</h3>
                        <h4>Expert Evaluation</h4>
                        <h5>We’ll send a licensed and highly trained expert to your home to conduct a comprehensive evaulation.</h5>
                    </div>
                    <div className="DryerVentHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit3.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Sit Back & Relax</h4>
                        <h5>Our team of expert technicians will solve all your dryer vent issues, ensuring safety, efficiency, and peace of mind!</h5>
                    </div>
                </div>
                <h6>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to get started.</h6>
            </div>
            {/* MainBanner2Top2 */}
            <div className="DryerVentServices" id="ourservices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryercleaning.jpg`)} alt="Dryer Vent Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>DRYER VENT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lint Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Clogged Vent Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Inspection & Repair</h2>
                            </div>
                            <h4>Prevent fire hazards and improve efficiency with Rocket Air Care’s dryer vent cleaning services. Clogged dryer vents are a leading cause of house fires and can increase energy bills. Our experienced technicians use powerful tools to remove lint and debris, restoring proper airflow to your dryer. Protect your home and save money with this essential service. Call Rocket Air Care today to schedule your dryer vent cleaning and enjoy peace of mind with a safer, more efficient home.</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryerrepair.jpg`)} alt="Dryer Vent Repair" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>DRYER VENT REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Damaged Vent Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Sealing Vent Leaks</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Connection Fixes</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Safety Compliance</h2>
                            </div>
                            <h4>Keep your dryer vent system in top shape with Rocket Air Care’s expert repair services. Whether it’s replacing damaged vents, sealing leaks, or fixing poor connections, our team ensures your dryer vent system operates safely and efficiently. Avoid energy waste and potential hazards by addressing vent issues promptly. Call Rocket Air Care today and let our professionals handle all your dryer vent repair needs with care and precision.</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryerinspection.jpg`)} alt="Dryer Vent Inspection" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>DRYER VENT INSPECTION</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Risk Assessment</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Airflow Testing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Moisture Buildup Detection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Professional Recommendations</h2>
                            </div>
                            <h4>Ensure the safety and efficiency of your dryer vent system with Rocket Air Care’s professional inspection services. Our technicians conduct thorough checks for fire risks, blockages, and moisture buildup, providing expert recommendations to address any issues. Regular inspections can prevent costly repairs and keep your home safe. Schedule a dryer vent inspection with Rocket Air Care today for peace of mind and improved performance.</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>AIR DUCT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Testing</h2>
                            </div>
                            <h4>Breathe cleaner air with Rocket Air Care’s professional air duct cleaning services. Over time, dust, debris, and allergens build up in your air ducts, reducing air quality and efficiency. Our skilled technicians use advanced equipment to thoroughly clean your ducts, improving airflow and creating a healthier home environment. Whether it’s a routine cleaning or addressing allergy concerns, we’ve got you covered. Call Rocket Air Care today and enjoy fresher, healthier air for your family—your comfort is our priority!</h4>
                        </div>
                    </a>
                </div>
            </div>
            {/* MainBanner4 */}
            <div className="MainBanner4">
                <div className="MainBanner4Right">
                    <h1>Our Comprehensive Air Duct Services</h1>
                    <h2>At Rocket Air Care, we offer a full suite of air duct services designed to improve your indoor air quality and HVAC system performance. Our services include professional air duct cleaning, detailed inspections, expert repairs, and routine maintenance. With advanced equipment and skilled technicians, we ensure your air ducts are free of dust, allergens, and debris, creating a cleaner, healthier, and more efficient home environment. Trust Rocket Air Care to keep your air ducts in peak condition!</h2>
                    <div className="MainBafnner4RightBenefits">
                        <a >Air duct cleaning</a>
                        <a >Professional air duct cleaning</a>
                        <a >Air duct repair</a>
                        <a >Dryer vent cleaning</a>
                        <a >UV light sanitation</a>
                        <a >Air quality testing</a>
                        <a >Mold removal</a>
                        <a >Allergen removal</a>
                        <a >HVAC system cleaning</a>
                        <a >Air duct inspections</a>
                        <a >Affordable air duct services</a>
                        <a >Licensed and insured technicians</a>
                        <a >Energy-efficient air care</a>
                        <a >Same-day air duct service</a>
                        <a >Fire hazard prevention</a>
                        <a >Indoor air quality improvement</a>
                        <a >Clogged vent clearing</a>
                        <a >Duct sanitization</a>
                        <a >Fully stocked service trucks</a>
                        <a >Residential air duct cleaning</a>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At Rocket AirCare, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality dryer vent and air duct cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to dryer vent and air duct cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Rocket Air Care" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

